<div class="qrd-wrapper" [class.wa]="data.channelType === 'whatsapp'" [class.tg]="data.channelType === 'telegram'">

  <div class="qrd-header">
    <div class="qrd-header-icon">
      <mat-icon>{{ data.channelType === 'whatsapp' ? 'chat' : 'send' }}</mat-icon>
    </div>
    <div class="qrd-header-text">
      <span class="qrd-channel-name">{{ data.channelName }}</span>
      <span class="qrd-subtitle">Scan to start chatting</span>
    </div>
    <button mat-icon-button class="qrd-close-btn" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="qrd-body">
    <div class="qrd-qr-card">
      <qrcode
        [qrdata]="data.qrLink"
        [width]="200"
        [errorCorrectionLevel]="'M'"
        (contextmenu)="$event.preventDefault()">
      </qrcode>
    </div>

    <div class="qrd-steps">
      <div class="qrd-step">
        <span class="qrd-step-num">1</span>
        <span class="qrd-step-text">Open your camera</span>
      </div>
      <div class="qrd-step-arrow">→</div>
      <div class="qrd-step">
        <span class="qrd-step-num">2</span>
        <span class="qrd-step-text">Point at the QR</span>
      </div>
      <div class="qrd-step-arrow">→</div>
      <div class="qrd-step">
        <span class="qrd-step-num">3</span>
        <span class="qrd-step-text">Start chatting</span>
      </div>
    </div>
  </div>

  <div class="qrd-footer">
    <span class="qrd-divider-text">or</span>
    <a [href]="data.webLink" target="_blank" rel="noopener noreferrer" mat-stroked-button class="qrd-open-btn" (click)="dialogRef.close()">
      <mat-icon>open_in_new</mat-icon>
      Open {{ data.channelName }} directly
    </a>
  </div>

</div>
